import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  ogType?: string;
  language?: string;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = 'AI Interview Prep — Tailored Practice Questions | my-aitools',
  description = 'AI Interview Prep — paste a job description, get 12 tailored interview questions with strong suggested answers. Free, no sign-up.',
  canonicalUrl,
  ogType = 'website',
  language = 'en',
}) => {
  const siteUrl = window.location.origin;
  const fullCanonicalUrl = canonicalUrl || `${siteUrl}/interview-prep/`;
  const ogImage = 'https://my-aitools.online/og.png';

  return (
    <Helmet>
      <html lang={language} dir={language === 'ar' ? 'rtl' : 'ltr'} />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href={fullCanonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={language === 'ar' ? 'ar_AE' : 'en_US'} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEOHead;
